import { TOP_BAR_COMMON_SX } from './aiAgentsConsts';
import { Box, Stack } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import useAiAgents from './useAiAgents';
import AgentCard from './AgentCard';
import { AgentType } from '@server/ai';
import ToggleExpandButton from './ToggleExpandButton';
import NewAgentButton from './NewAgentButton';
import usePopover from '../../hooks/usePopover';
import useAgentsChats from './useAgentsChats';
import ClosePanelButton from './ClosePanelButton';
import useAgentsToRender from './useAgentsToRender';
import AgentCardSkeleton from './AgentCardSkeleton';
import { UserSupportAgentCard } from './userSupport/UserSupportAgentCard';

const AgentsHomeCardsCollapsed = ({
  closePanel,
  onNewAgentClick,
}: {
  closePanel?: () => void;
  onNewAgentClick: (type: AgentType) => void;
}) => {
  const { setAgentClickHandler } = useAgentsChats();
  const { agentsIsLoading } = useAiAgents();
  const agentsToRender = useAgentsToRender();
  const { existingAgents, canCreateNewAgents } = agentsToRender ?? {};
  const menuPopoverProps = usePopover();
  const renderLoading = agentsIsLoading && !agentsToRender;

  return (
    <Stack height="100%" width="100%">
      <Box
        sx={{
          justifyContent: 'flex-end',
          ...TOP_BAR_COMMON_SX,
        }}
      >
        <ToggleExpandButton />
        <ClosePanelButton closePanel={closePanel} />
      </Box>
      <Stack
        sx={{
          overflow: 'hidden',
        }}
      >
        <Stack height="100%" gap={3}>
          <Stack
            padding="0 16px"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              gap: '16px',
              alignItems: 'center',
            }}
          >
            <Typography variant="h2" color={colors.grey[800]}>
              Your agents
            </Typography>
            {canCreateNewAgents && (
              <Stack minWidth="fit-content">
                <NewAgentButton onNewAgentClick={onNewAgentClick} {...menuPopoverProps} />
              </Stack>
            )}
          </Stack>
          {renderLoading && (
            <Stack gap={3} padding="0 16px">
              <AgentCardSkeleton />
              <AgentCardSkeleton />
            </Stack>
          )}

          {!renderLoading && (
            <Stack
              gap={2}
              padding="0 16px 24px"
              sx={{
                overflow: 'auto',
              }}
            >
              {existingAgents?.map((agent) => (
                <AgentCard
                  key={agent.id}
                  agent={agent}
                  onClick={() =>
                    setAgentClickHandler({
                      agent,
                    })
                  }
                  opacity={menuPopoverProps.isPopoverOpen ? 0.6 : 1}
                />
              ))}
              <UserSupportAgentCard section="chat" />
            </Stack>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AgentsHomeCardsCollapsed;
